
import {get_qiniu_token,toQiniu} from "../../api/open";
function deleteInputFile(){
    let inputFile=document.getElementById('inputFile');
    inputFile && inputFile.parentNode.removeChild(inputFile); 
}
export const uploadFile=(size,accept)=>{
    return new Promise((resolve,reject)=>{
        deleteInputFile();
        let inputFile=document.createElement('input');
        inputFile.type='file';
        inputFile.id='inputFile';
        inputFile.accept=accept;
        document.body.appendChild(inputFile);
        inputFile.click();
        inputFile.addEventListener('change',(e)=>{
            let file=e.target.files[0];
            let formdata=new FormData();
            formdata.append('file',file);
            if(file&&file.size>size*1024*1024){
                reject(`文件大小不能超过${size}M`)
            }else{
                get_qiniu_token().then(res=>{
                    let data=res.data;
                    if(data.code==='000'){
                        let upToken=data.content.upToken;
                        let domain=data.content.domain;
                        formdata.append('token',upToken);
                        toQiniu(formdata).then(res=>{
                            let data=res.data;
                            let url='https://'+domain+'/'+data.key;
                            let result={
                                url:url,
                                name:file.name
                            }
                            deleteInputFile();
                            resolve(result);
                        }).catch(err=>{
                            console.log(err)
                        })  
                    }
                }).catch(err2=>{
                    console.log(err2)
                })
            }
        })
    })
    
}